export default {
  name: 'warrantyView'
}
